export default {
  name: 'warrantyView'
}
